import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Package } from "lucide-react";

const CONDITION_COLORS = {
    New: "#4ade80",
    Used: "#facc15",
    "For Parts": "#fb923c",
    "Not Working": "#ef4444",
};

export default function PartCard({ part }) {
    const c = part || {};
    const cond = CONDITION_COLORS[c.condition] || "#8c8c8c";
    return (
        <Link
            to={`/parts/${c.part_id}`}
            data-testid={`part-card-${c.part_id}`}
            className="block rounded-2xl overflow-hidden group"
            style={{
                background: "linear-gradient(160deg, rgba(20,20,20,0.7), rgba(20,20,20,0.4))",
                border: "1px solid rgba(255,255,255,0.06)",
            }}
        >
            <div className="aspect-[4/3] relative overflow-hidden">
                {c.photos?.[0] ? (
                    <img
                        src={c.photos[0]}
                        alt={c.title}
                        loading="lazy"
                        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center bg-onyx-900">
                        <Package className="w-10 h-10 text-onyx-700" />
                    </div>
                )}
                <span
                    className="absolute top-2 left-2 text-[10px] font-bold tracking-widest px-2 py-0.5 rounded-full"
                    style={{ background: `${cond}22`, color: cond, border: `1px solid ${cond}66` }}
                >
                    {c.condition?.toUpperCase()}
                </span>
                <span
                    className="absolute top-2 right-2 text-[10px] font-bold tracking-widest px-2 py-0.5 rounded-full uppercase"
                    style={{ background: "rgba(0,0,0,0.65)", color: "#fff" }}
                >
                    {c.category}
                </span>
            </div>
            <div className="p-3">
                <div className="text-sm font-semibold text-white truncate">{c.title}</div>
                {c.fits && (
                    <div className="text-[11px] text-onyx-500 truncate mt-0.5">Fits {c.fits}</div>
                )}
                <div className="flex items-center justify-between mt-2">
                    <span className="text-lg font-bold" style={{ color: "#E10600" }}>
                        ${c.price?.toLocaleString()}
                    </span>
                    {c.location && (
                        <span className="text-[11px] text-onyx-500 inline-flex items-center gap-1 truncate ml-2">
                            <MapPin className="w-3 h-3 shrink-0" /> {c.location}
                        </span>
                    )}
                </div>
            </div>
        </Link>
    );
}
